import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6843d610"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" +1백원 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" +1천원 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" +1만원 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" +5만원 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" +1만원 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" +5만원 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" +10만원 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 전부팔기 ")
const _hoisted_9 = { class: "pad-container" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "00", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "0", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/backspace@3x.png",
  class: "Delete",
  alt: "backspace"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.typeRef === 1)
      ? (_openBlock(), _createBlock(_component_ag_box, {
          key: 0,
          gap: "sp8",
          "justify-content": "center",
          dp: "flex"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_button, {
              block: "xs",
              corner: "sm",
              px: "10px",
              outline: "gray6",
              color: "gray3",
              style: {"font-weight":"400"},
              onClickCapture: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addNumber(100)))
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_ag_button, {
              block: "xs",
              corner: "sm",
              px: "10px",
              outline: "gray6",
              color: "gray3",
              style: {"font-weight":"400"},
              onClickCapture: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addNumber(1000)))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_ag_button, {
              block: "xs",
              corner: "sm",
              px: "10px",
              outline: "gray6",
              color: "gray3",
              style: {"font-weight":"400"},
              onClickCapture: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addNumber(10000)))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_ag_button, {
              block: "xs",
              corner: "sm",
              px: "10px",
              outline: "gray6",
              color: "gray3",
              style: {"font-weight":"400"},
              onClickCapture: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addNumber(50000)))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_ctx.typeRef === 2)
        ? (_openBlock(), _createBlock(_component_ag_box, {
            key: 1,
            gap: "sp8",
            "justify-content": "center",
            dp: "flex"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_button, {
                block: "xs",
                corner: "sm",
                px: "10px",
                outline: "gray6",
                color: "gray3",
                style: {"font-weight":"400"},
                onClickCapture: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addNumber(10000)))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_ag_button, {
                block: "xs",
                corner: "sm",
                px: "10px",
                outline: "gray6",
                color: "gray3",
                style: {"font-weight":"400"},
                onClickCapture: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addNumber(50000)))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_ag_button, {
                block: "xs",
                corner: "sm",
                px: "10px",
                outline: "gray6",
                color: "gray3",
                style: {"font-weight":"400"},
                onClickCapture: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addNumber(100000)))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_ag_button, {
                block: "xs",
                corner: "sm",
                px: "10px",
                outline: "gray6",
                color: "gray3",
                style: {"font-weight":"400"},
                onClickCapture: _ctx.sellAll
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["onClickCapture"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0,1,2], (row) => {
        return _createElementVNode("div", {
          key: row,
          class: "row"
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (col) => {
            return _createElementVNode("div", {
              key: col,
              class: "ion-activatable ripple-parent letter",
              onClick: ($event: any) => (_ctx.addNumberStr(row * 3 + col))
            }, [
              _createElementVNode("span", null, _toDisplayString(row * 3 + col), 1),
              _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
            ], 8, _hoisted_10)
          }), 64))
        ])
      }), 64)),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", {
          class: "ion-activatable ripple-parent letter",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addNumberStr('00')))
        }, [
          _hoisted_12,
          _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
        ]),
        _createElementVNode("div", {
          class: "ion-activatable ripple-parent letter",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addNumberStr('0')))
        }, [
          _hoisted_13,
          _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
        ]),
        _createElementVNode("div", {
          class: "ion-activatable ripple-parent letter",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clearNumber('del')))
        }, [
          _hoisted_14,
          _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
        ])
      ])
    ])
  ], 64))
}